// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RegionSelectorForm__container-b7ce9d {
  width: 100%;
}

.RegionSelectorForm__form-d128ec {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.RegionSelectorForm__form-control-f326ab {
  width: 100%;
  margin-bottom: 24px;
}

.RegionSelectorForm__submit-e2fc10 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/components/RegionSelectorForm/DiscoverDestinationSelectorForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n}\n\n.form {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.form-control {\n  width: 100%;\n  margin-bottom: 24px;\n}\n\n.submit {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RegionSelectorForm__container-b7ce9d`,
	"form": `RegionSelectorForm__form-d128ec`,
	"form-control": `RegionSelectorForm__form-control-f326ab`,
	"formControl": `RegionSelectorForm__form-control-f326ab`,
	"submit": `RegionSelectorForm__submit-e2fc10`
};
module.exports = ___CSS_LOADER_EXPORT___;
